import React, { useState } from "react";
import { Button } from "react-bootstrap";
import ProductsLearnMoreModal from "./ProductsLearnMoreModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";

export default function ProductsEventsAndAlerting() {
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleLearnMoreClick = (event, product) => {
    event.preventDefault();
    event.stopPropagation();
    setSelectedProduct(product);
  };

  const handleCloseModal = () => {
    setSelectedProduct(null);
  };

  return (
    <div className="bg-page rounded-4 p-3 mb-5">
      <div className="text-center mb-4">
        <img
          src="/assets/products/images/eventsalert.png"
          alt="Events and Alerting"
          className="img-fluid rounded-4"
          style={{ maxHeight: "280px", objectFit: "cover" }}
        />
        <div className="fw-bold text-navy text-center fs-2 mt-3">
          Events and Alerting
        </div>
      </div>

      <div>
        <p className="fs-5 mt-3">
          When the worst happens, the ability to stay in control and act
          decisively is critical.
        </p>
        <p className="fs-5 ">
          Effective incident management isn’t just about raising the alarm; it’s
          about coordinating the response, maintaining clarity, and ensuring
          communication is structured and reliable throughout.
        </p>
        <p className="fs-5 ">
          Boomerang’s Events and Alerting capability is built to do exactly
          that. It enables organisations to initiate, manage and resolve events
          in real time, with workflows automatically applied to control
          processes, communications, and escalation paths from the outset.
        </p>
        <p className="fs-5 ">
          Events can be triggered manually via the mapping interface or
          automatically through integrated monitoring. Once active, boomLogic
          orchestrates the response, providing full visibility of the situation
          while allowing teams to intervene at any point where needed.
        </p>
        <p className="fs-5 ">
          From a single user interface, teams can identify affected assets and
          contacts, manage groups, and execute predefined workflows.
          Communications, ticketing, escalations and process steps can all be
          managed in real time, ensuring a consistent and controlled response
          even as conditions evolve.
        </p>
        <p className="fs-5 ">
          Real-time reporting keeps stakeholders informed during an event, while
          post-event analysis provides a clear view of performance, outcomes and
          areas for improvement.
        </p>
        <p className="fs-5 ">
          The result is simple: faster response times, controlled execution, and
          confidence that critical events are being managed properly.
        </p>
        <p className="fs-5 ">
          Events and Alerting within Boomerang can also be combined with:
        </p>
        <p>
          <div className="align-items-center gap-2">
            <a
              href="/workflows/products/monitoringAndAlerting"
              className="text-decoration-none text-navy"
            >
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">Monitoring</span>
            </a>
          </div>

          <div className="align-items-center gap-2">
            <a
              href="/workflows/products/solutions"
              className="text-decoration-none text-navy"
            >
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">Solutions</span>
            </a>
          </div>
          <div className="align-items-center gap-2">
            <a
              href="/workflows/products/assetManagement"
              className="text-decoration-none text-navy"
            >
              <FontAwesomeIcon
                icon={faCircle}
                className="text-navy"
                width={10}
              />
              <span className="fs-5 ms-1">Assets</span>
            </a>
          </div>
        </p>
      </div>

      <div className="text-center d-flex justify-content-center gap-3 mt-4">
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) => handleLearnMoreClick(event, { name: "trial" })}
        >
          Free trial
        </Button>
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) => handleLearnMoreClick(event, { name: "buy" })}
        >
          Buy
        </Button>
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) =>
            handleLearnMoreClick(event, { name: "more information" })
          }
        >
          More Information
        </Button>
        <ProductsLearnMoreModal
          selectedProduct={selectedProduct}
          handleCloseModal={handleCloseModal}
        />
      </div>
    </div>
  );
}
